import React from 'react';
import { Stack } from '@fluentui/react';
import { IIncomeInvoiceResourceShortProps } from '../../../../../../props/finance/incomes/invoices/invoice';
import IncomeInvoiceSummaryChart from './summary';
import IncomeInvoiceStatusPieChart from './pie';

type IncomeInvoiceChartsProps = {
    invoices?: IIncomeInvoiceResourceShortProps[];
}

const IncomeInvoiceCharts: React.FC<IncomeInvoiceChartsProps> = (props: IncomeInvoiceChartsProps) => {
    return <Stack horizontal tokens={{ childrenGap: 20 }} styles={{ root: { width: '100%' } }}>
        <Stack styles={{ root: { width: '60%' } }}>
            <IncomeInvoiceSummaryChart invoices={props.invoices} />
        </Stack>
        <Stack styles={{ root: { width: '40%' } }}>
            <IncomeInvoiceStatusPieChart invoices={props.invoices} />
        </Stack>
    </Stack>;
};

export default IncomeInvoiceCharts;
